import { render } from "./BookingPayment.vue?vue&type=template&id=521e09fa&scoped=true"
import script from "./BookingPayment.vue?vue&type=script&lang=js"
export * from "./BookingPayment.vue?vue&type=script&lang=js"

import "./BookingPayment.vue?vue&type=style&index=0&id=521e09fa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/abdom-clean-homes-booking/abdom-clean-homes-booking/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521e09fa"]])

export default __exports__